exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background: rgba(209, 207, 207, 0.363) !important;\n  padding: 0px 0px;\n  font-size: inherit;\n  border-radius: 0px;\n  font-weight: normal;\n  outline: none;\n}\n", ""]);

// exports
